import { resizeAllCharts } from "../expendPlugins/chart/chart";
import { jfrefreshgrid_rhcw } from "../global/refresh";
import Store from "../store";
import imageCtrl from "./imageCtrl";
import luckysheetPostil from "./postil";
import { changeSheetContainerSize } from "./resize";
import server from "./server";
import sheetmanage from "./sheetmanage";

let luckysheetZoomTimeout = null;

export function zoomChange(ratio) {
  if (Store.flowdata == null || Store.flowdata.length == 0) {
    return;
  }

  clearTimeout(luckysheetZoomTimeout);
  luckysheetZoomTimeout = setTimeout(() => {
    if (Store.clearjfundo) {
      Store.jfredo.push({
        type: "zoomChange",
        zoomRatio: Store.zoomRatio,
        curZoomRatio: ratio,
        sheetIndex: Store.currentSheetIndex,
      });
    }

    Store.zoomRatio = ratio;

    let currentSheet = sheetmanage.getSheetByIndex();

    if (currentSheet.config == null) {
      currentSheet.config = {};
    }

    if (currentSheet.config.sheetViewZoom == null) {
      currentSheet.config.sheetViewZoom = {};
    }

    let type = currentSheet.config.curentsheetView;
    if (type == null) {
      type = "viewNormal";
    }
    currentSheet.config.sheetViewZoom[type + "ZoomScale"] = ratio;

    server.saveParam("all", Store.currentSheetIndex, Store.zoomRatio, {
      k: "zoomRatio",
    });
    server.saveParam(
      "cg",
      Store.currentSheetIndex,
      currentSheet.config["sheetViewZoom"],
      { k: "sheetViewZoom" }
    );

    // 优先刷新视图，再刷新图片和图表位置
    zoomRefreshView();

    //批注
    luckysheetPostil.buildAllPs(currentSheet.data);

    //图片
    imageCtrl.images = currentSheet.images;
    imageCtrl.allImagesShow();
    imageCtrl.init();

    // 图表
    resizeAllCharts();
  }, 100);
}

export function zoomRefreshView() {
  // let $scrollLeft = $("#luckysheet-scrollbar-x"), $scrollTop = $("#luckysheet-scrollbar-y");
  // let sl = $scrollLeft.scrollLeft(), st = $scrollTop.scrollTop();

  // let wp = $scrollLeft.find("div").width(), hp = $scrollTop.find("div").height();
  const $scrollBarX = $("#luckysheet-scrollbar-x");
  const $scrollBarY = $("#luckysheet-scrollbar-y");

  const $scrollBarXInner = $scrollBarX.find("div");
  const $scrollBarYInner = $scrollBarY.find("div");

  const originScrollLeft = $scrollBarX.scrollLeft();
  const originContainerWidth = parseFloat($scrollBarX.css("width"));
  const originInnerWidth =
    parseFloat($scrollBarXInner.css("width")) -
    parseFloat($scrollBarX.css("left"));

  const originScrollTop = $scrollBarY.scrollTop();
  const originContainerHeight = parseFloat($scrollBarY.css("height"));
  const originInnerHeight =
    parseFloat($scrollBarYInner.css("height")) -
    parseFloat($scrollBarY.css("top"));

  const xRatio =
    (originContainerWidth / 2 + originScrollLeft) / originInnerWidth;

  const yRatio =
    (originContainerHeight / 2 + originScrollTop) / originInnerHeight;

  jfrefreshgrid_rhcw(Store.flowdata.length, Store.flowdata[0].length);
  changeSheetContainerSize();

  // 改变滚动条滚动距离来达到滚动位置不变的效果
  const changedContainerWidth = parseFloat($scrollBarX.css("width"));
  const changedInnerWidth =
    parseFloat($scrollBarXInner.css("width")) -
    parseFloat($scrollBarX.css("left"));

  const changedContainerHeight = parseFloat($scrollBarY.css("height"));
  const changedInnerHeight =
    parseFloat($scrollBarYInner.css("height")) -
    parseFloat($scrollBarY.css("top"));

  $scrollBarX.scrollLeft(
    changedInnerWidth * xRatio - changedContainerWidth / 2
  );
  $scrollBarY.scrollTop(
    changedInnerHeight * yRatio - changedContainerHeight / 2
  );

  // let wc = $scrollLeft.find("div").width(), hc = $scrollTop.find("div").height();

  // $scrollLeft.scrollLeft(sl+wc-wp);
  // $scrollTop.scrollTop(st+hc-hp);
}

export function zoomInitial() {
  $("#luckysheet-zoom-minus").click(function() {
    let currentRatio;
    if (Store.zoomRatio == null) {
      currentRatio = Store.zoomRatio = 1;
    } else {
      currentRatio = Math.ceil(Store.zoomRatio * 10) / 10;
    }

    currentRatio = currentRatio - 0.1;

    if (currentRatio == Store.zoomRatio) {
      currentRatio = currentRatio - 0.1;
    }

    if (currentRatio <= 0.1) {
      currentRatio = 0.1;
    }

    // Store.zoomRatio = currentRatio;
    zoomChange(currentRatio);
    zoomNumberDomBind(currentRatio);
  });

  $("#luckysheet-zoom-plus").click(function() {
    let currentRatio;
    if (Store.zoomRatio == null) {
      currentRatio = Store.zoomRatio = 1;
    } else {
      currentRatio = Math.floor(Store.zoomRatio * 10) / 10;
    }

    currentRatio = currentRatio + 0.1;

    if (currentRatio == Store.zoomRatio) {
      currentRatio = currentRatio + 0.1;
    }

    if (currentRatio >= 4) {
      currentRatio = 4;
    }

    // Store.zoomRatio = currentRatio;
    zoomChange(currentRatio);
    zoomNumberDomBind(currentRatio);
  });

  $("#luckysheet-zoom-slider").mousedown(function(e) {
    let xoffset = $(this).offset().left,
      pageX = e.pageX;

    let currentRatio = positionToRatio(pageX - xoffset);
    // Store.zoomRatio = currentRatio;
    zoomChange(currentRatio);
    zoomNumberDomBind(currentRatio);
  });

  $("#luckysheet-zoom-cursor")
    .mousedown(function(e) {
      let curentX = e.pageX,
        cursorLeft = parseFloat($("#luckysheet-zoom-cursor").css("left"));
      $("#luckysheet-zoom-cursor").css("transition", "none");
      $(document)
        .off("mousemove.zoomCursor")
        .on("mousemove.zoomCursor", function(event) {
          let moveX = event.pageX;
          let offsetX = moveX - curentX;
          // console.log(moveX, curentX, offsetX);
          // curentX = moveX;
          // let left = parseFloat($("#luckysheet-zoom-cursor").css("left"));
          let pos = cursorLeft + offsetX;
          let currentRatio = positionToRatio(pos);

          if (currentRatio > 4) {
            currentRatio = 4;
            pos = 100;
          }

          if (currentRatio < 0.1) {
            currentRatio = 0.1;
            pos = 0;
          }

          // Store.zoomRatio = currentRatio;
          zoomChange(currentRatio);
          let r = Math.round(currentRatio * 100) + "%";
          $("#luckysheet-zoom-ratioText").html(r);
          $("#luckysheet-zoom-cursor").css("left", pos - 4);
        });

      $(document)
        .off("mouseup.zoomCursor")
        .on("mouseup.zoomCursor", function(event) {
          $(document).off(".zoomCursor");
          $("#luckysheet-zoom-cursor").css("transition", "all 0.3s");
        });

      e.stopPropagation();
    })
    .click(function(e) {
      e.stopPropagation();
    });

  $("#luckysheet-zoom-ratioText").click(function() {
    // Store.zoomRatio = 1;
    zoomChange(1);
    zoomNumberDomBind(1);
  });

  zoomNumberDomBind(Store.zoomRatio);
}

function zoomSlierDown() {}

function positionToRatio(pos) {
  let ratio = 1;
  if (pos < 50) {
    ratio = Math.round(((pos * 1.8) / 100 + 0.1) * 100) / 100;
  } else if (pos > 50) {
    ratio = Math.round((((pos - 50) * 6) / 100 + 1) * 100) / 100;
  }

  return ratio;
}

function zoomSlierDomBind(ratio) {
  let domPos = 50;
  if (ratio < 1) {
    domPos = Math.round(((ratio - 0.1) * 100) / 0.18) / 10;
  } else if (ratio > 1) {
    domPos = Math.round(((ratio - 1) * 100) / 0.6) / 10 + 50;
  }
  $("#luckysheet-zoom-cursor").css("left", domPos - 4);
}

export function zoomNumberDomBind(ratio) {
  let r = Math.round(ratio * 100) + "%";
  $("#luckysheet-zoom-ratioText").html(r);
  zoomSlierDomBind(ratio);
}
